/**
 * Inline health-флаг на узле NarrativeBlock'а — иконка + сообщение.
 *
 * Источник правды — `Snapshot.health`; здесь — проекция флагов на
 * конкретный узел, которая считается в builder'е и кладётся в
 * `NarrativeBlock.health`.
 */

import { Group, Text } from '@mantine/core';
import type { HealthFlag, Severity } from '@pflow/shared/v2';

const COLOR: Record<Severity, string> = {
    ok:        'gray',
    neutral:   'gray',
    attention: 'yellow',
    critical:  'red',
};

const ICON: Record<Severity, string> = {
    ok:        '✓',
    neutral:   '·',
    attention: '⚠️',
    critical:  '🚨',
};

export function HealthInlineFlag({ flag }: { flag: HealthFlag }): JSX.Element {
    return (
        <Group gap={4} wrap="nowrap">
            <Text span fz="xs">{ICON[flag.severity]}</Text>
            <Text span fz="xs" c={COLOR[flag.severity]}>{flag.message}</Text>
        </Group>
    );
}

export function HealthInlineList({ flags }: { flags: HealthFlag[] }): JSX.Element | null {
    if (flags.length === 0) return null;
    return (
        <Group gap="xs" wrap="wrap" mt={4}>
            {flags.map((f, i) => <HealthInlineFlag key={i} flag={f} />)}
        </Group>
    );
}
